import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description CustomCard is a reusable UI component that wraps content inside a styled MUI Card.
 * It optionally renders a title above the card and accepts custom styling via props.
 * @param String title: title displayed above the card (optional)
 * @param {JSX.Element} children:  The content to render inside the card (optional)
 * @param String classes: Additional classes to apply to the outer wrapper div, usually used to define the height of the card (optional)
 * @param String classContent: Classes to apply to the CardContent section, usually used to define the padding/margin of the card (optional)
 * @param String classCard:  Classes to apply to the Card component, border, background (optional)
 * @param event click:  Click event for the card (optional)
 * @returns {JSX.Element}
 */
const CustomCard = ({ title='', children, classes='', classContent='', classCard='', click=null}) => {
    return (
        <div
            className={`${classes} ${click != null ? 'cursor-pointer' : ''}`}
            onClick={()=>{
                if(click) click();
            }}
        >
            {title &&
                <Typography className='title-section mb-3'>
                    {title}
                </Typography>
            }
            <Card variant={classCard.includes('border-0') ? 'border-0 shadow-0' : 'outlined'} className={`${classes} ${classCard}`}>
                <CardContent className={classContent}>{children}</CardContent>
            </Card>
        </div>
    );
};

export default CustomCard;
